if (window.location.href.indexOf("gift-earrings") > -1){
    window.location.replace("https://mayamarjewelry.com/collections/earrings-v2/products/ella-huggies");
};

document.addEventListener('rebuy:smartcart.ready', function(event){
  
  //console.log('rebuy:smartcart.ready event', event.detail);
  
  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

    '<div class="container-progress-bar">' +
    
        '<h3 class="progress-bar__title">Free shipping on all orders</h3>'+
        
        '<section class="progress-bar-cart">'+
        
        	'<div class="progress-bar-cart__container">'+
        		'<div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>'+
        	'</div>'+
        
        	'<div class="progress-bar__icon">'+
        		'<div id="container-icon__free-shipping" class="progress-bar__icon-container">'+
        			'<i id="icon__free-shipping" class="fas fa-lock"></i>'+
        		'</div>'+
        		'<p class="progress-bar__icon-text">Free Shipping</p>'+
        	'</div>'+
        
        
        
        	'<div class="progress-bar-cart__container">'+
        		'<div id="progress-bar__5-off" class="progress-bar-cart__bar"></div>'+
        	'</div>'+
        
        	'<div class="progress-bar__icon">'+
        		'<div id="container-icon__5-off" class="progress-bar__icon-container">'+
        			'<i id="icon__5-off" class="fas fa-lock"></i>'+
        		'</div>'+
        		'<p class="progress-bar__icon-text">Gift with Purchase!</p>'+
        	'</div>'+
        
        '</section>'+
    
        '<p class="disclaimer-message">* earrings available while supplies last.</p>' +

    '</div>'
  );
  
});

document.addEventListener('rebuy:cart.change', function(event){
  
  //console.log('rebuy:cart.change event', event.detail);

  function $progress_bar(){

    
    // VAR REBUY

    var $total_price = event.detail.cart.cart.total_price;
    var $array_products = event.detail.cart.cart.items;

    // PRICES

    var $price_promotion_one = 1 - $total_price;
    var $promotion_one = $price_promotion_one /= Math.pow(10, 2);

    var $price_promotion_two = 15000 - $total_price;
    var $promotion_two = $price_promotion_two /= Math.pow(10, 2);

    // PRODUCT OFFER

    function $product_offer(productId) {
      return productId.product_id === 6780030320689;
    };

    var $validation_product = $array_products.find($product_offer);

     // FUNCTION PROGRESS BAR    

      if($validation_product === undefined){

        if ($total_price <= 0) {

          $("#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "0%",}, 1000);
          $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
          $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
          $("#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
          $("#icon__free-shipping,#icon__5-off").css("color", "#000000");
          $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on all orders</h3>');

        } else if ($total_price > 0 && $total_price <= 14999) {

          $("#progress-bar__free-shipping").animate({width: "100%",}, 1000);
          $("#progress-bar__5-off").animate({width: "0%",}, 1000);
          
          
          $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
		  $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
          
          $("#container-icon__free-shipping").css({"background-color": "#000000", "border-color": "#000000"});
          $("#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
          
          
          $("#icon__free-shipping").css("color", "white");
          $("#icon__5-off").css("color", "#000000");
          
          
          $(".progress-bar__title").replaceWith(
            '<div class="progress-bar__title">'+
              '<h3>You Unlocked Free Shipping</h3>'+
              '<h5>You need <b>$' + $promotion_two + '</b> to get your gift earring</h5>'+
            '</div>'
          );

        } else if ($total_price >= 15000) {

          $("#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "100%",}, 1000);
          $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
          $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-check-circle"></i>');
          $("#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "#000000", "border-color": "#000000"});
          $("#icon__free-shipping,#icon__5-off").css("color", "white");

          $(".progress-bar__title").replaceWith(
            '<div class="progress-bar__title">'+
              '<h3>You have Free Shipping + Gift Earrings</h3>'+
              '<p class="select-color-fanny">Select the color earrings:</p>'+
              '<form class="container-variantes">'+
                '<div class="container-variants"><input type="radio" name="vaiantes-cart" class="colors-towel-gift" id="blue" value="39950949842993"><label for="blue">Blue</label><p class="variant-title">Blue</p></div>'+
                '<div class="container-variants"><input type="radio" name="vaiantes-cart" class="colors-towel-gift" id="wine" value="39950949875761"><label for="wine">Wine</label><p class="variant-title">Wine</p></div>'+
                '<div class="container-variants"><input type="radio" name="vaiantes-cart" class="colors-towel-gift" id="green" value="39950949908529"><label for="green">Green</label><p class="variant-title">Green</p></div>'+
                '<div class="container-variants"><input type="radio" name="vaiantes-cart" class="colors-towel-gift" id="sand" value="39950949941297"><label for="sand">Sand</label><p class="variant-title">Sand</p></div>'+ 
              '</form>'+
              '<button class="add-promotions-surprise add-promotions-surprise-btn-1">ADD YOUR FAVE!</button>'+
            '</div>'
          );
          
          $(document).on('click', '.colors-towel-gift', function (){
            $('.colors-towel-gift').removeClass('active-radio');
            $(this).addClass('active-radio');
            $(this).is(':checked');
            id = $(this).val();
            console.log(id);
          });
          
          $(document).on('click', '.add-promotions-surprise-btn-1', function() { 

            var seleccion = $('.colors-towel-gift:checked').val();
            
            var data = {
              "id": seleccion,
              "quantity": 1
            }

            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 
                $(".progress-bar__title").replaceWith(
                  '<div class="progress-bar__title">'+
                  '<h3>You have Free Shipping + Gift Earrings</h3>'+
                  '</div>'
                );
              }
            });

          });

        };

      } else {
        
        var $qty_product = $validation_product.quantity;

        if ($total_price <= 0 ) {

          if($qty_product >= 1){
              jQuery.post('/cart/update.js', {
                updates: {
                  39950949842993: 0,
                  39950949875761: 0,
                  39950949908529: 0,
                  39950949941297: 0
                }
              });
          };

          $("#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "0%",}, 1000);
          $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
          $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
          $("#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
          $("#icon__free-shipping,#icon__5-off").css("color", "#000000");
          $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on all orders</h3>');
          
        } else if ($total_price > 0 && $total_price <= 14999) {

          if($qty_product >= 1){
              jQuery.post('/cart/update.js', {
                updates: {
                  39950949842993: 0,
                  39950949875761: 0,
                  39950949908529: 0,
                  39950949941297: 0
                }
              });
          };

          $("#progress-bar__free-shipping").animate({width: "100%",}, 1000);
          $("#progress-bar__5-off").animate({width: "0%",}, 1000);
          
          $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
          $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
          
          $("#container-icon__free-shipping").css({"background-color": "#000000", "border-color": "#000000"});
          $("#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
          
          $("#icon__free-shipping").css("color", "white");
          $("#icon__5-off").css("color", "#000000");

            $(".progress-bar__title").replaceWith(
              '<div class="progress-bar__title">'+
              '<h3>You Unlocked Free Shipping</h3>'+
              '<h5>You need <b>$' + $promotion_two + '</b> to get your gift earrings</h5>'+
              '</div>'
            );
          

        }  else if ($total_price >= 15000) {
          
          // CONDICIONAL

            if($qty_product >= 2){
              jQuery.post('/cart/update.js', {
                updates: {
                  39950949842993: 0,
                  39950949875761: 0,
                  39950949908529: 0,
                  39950949941297: 0
                }
              });
            };

            $("#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "100%",}, 1000);
            $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
            $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-check-circle"></i>');
            $("#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "#000000", "border-color": "#000000"});
            $("#icon__free-shipping,#icon__5-off").css("color", "white");

            $(".progress-bar__title").replaceWith(
              '<div class="progress-bar__title">'+
              '<h3>You have Free Shipping + Gift Earrings</h3>'+
              '</div>'
            );

        };

      };

  };setTimeout($progress_bar, 1000);
  

});